// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sorter-and-items{flex-basis:50%}.timeline-divider{margin-left:-24px;max-width:none;width:calc(100% + 48px)}", ""]);
// Exports
module.exports = exports;
